import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './logpdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Arcsine distribution logarithm of probability density function (PDF).
*
* @module @stdlib/stats/base/dists/arcsine/logpdf
*
* @example
* var logpdf = require( '@stdlib/stats/base/dists/arcsine/logpdf' );
*
* var y = logpdf( 3.0, 2.0, 6.0 );
* // returns ~-1.694
*
* var mylogPDF = logpdf.factory( 6.0, 7.0 );
* y = mylogPDF( 7.0 );
* // returns Infinity
*
* y = mylogPDF( 5.0 );
* // returns -Infinity
*/

// MODULES //
var setReadOnly = __var_0__;
var logpdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( logpdf, 'factory', factory );


// EXPORTS //
export default logpdf;
